import styled from 'styled-components'

export const QuestionListItemUi = styled.div`
  margin-bottom: 15px;
  display: flex;
  align-items: center;
`
